import { useMutation, type UseMutationOptions } from '@tanstack/react-query'
import type { SetRequired } from 'type-fest'
import { indexedDB } from '../../indexedDB'
import type { PendingBulkRequest } from './schema'

type UpdateMutationParams = SetRequired<
  Omit<Partial<PendingBulkRequest>, 'operationId'>,
  'id'
>

type UpdateMutationOptions = UseMutationOptions<
  PendingBulkRequest | undefined,
  unknown,
  UpdateMutationParams
>

export const useUpdatePendingBulkRequest = (
  options?: UpdateMutationOptions
) => {
  return useMutation({
    ...options,
    mutationFn: async ({ operationData, id }) => {
      const payload = {
        operationData,
      }

      await indexedDB.pendingBulkRequests.update(id, payload)
      return indexedDB.pendingBulkRequests.get(id)
    },
  })
}
